export const mdScroll = () => {
    const topNavMd = document.querySelector('#top-nav-md');
    const topNavMdLight = document.querySelector('#top-nav-md-light');
    if(topNavMdLight){
        if(document.documentElement.scrollTop > topNavMdLight.clientHeight || document.body.scrollTop > topNavMdLight.clientHeight){
            topNavMdLight.classList.remove('py-4');
            topNavMdLight.classList.add('py-2');
            topNavMdLight.classList.add('shadow-sm');
        }
        else{
            topNavMdLight.classList.remove('py-2');
            topNavMdLight.classList.add('py-4');
            topNavMdLight.classList.remove('shadow-sm');
        }
    }
    if(topNavMd){
        const logoMobile = document.querySelector('#logo-md');
        const navLinks = topNavMd.querySelectorAll('.nav-link');
        if(document.documentElement.scrollTop > topNavMd.clientHeight || document.body.scrollTop > topNavMd.clientHeight){
            topNavMd.classList.add('scrolled');
            topNavMd.classList.add('shadow-sm');
            logoMobile.src = '/img/png/logo-original.png';
            navLinks.forEach(function(navLink){
                navLink.classList.remove('text-light');
                navLink.classList.add('text-dark');
            });
            topNavMd.classList.remove('py-4');
            topNavMd.classList.add('py-2');
        }
        else{
            topNavMd.classList.remove('scrolled');
            topNavMd.classList.remove('shadow-sm');
            logoMobile.src = '/img/png/logo-light.png';
            navLinks.forEach(function(navLink){
                navLink.classList.remove('text-dark');
                navLink.classList.add('text-light');
            });
            topNavMd.classList.remove('py-2');
            topNavMd.classList.add('py-4');
        }
    }
}
// export {navigation};